import { render, staticRenderFns } from "./bank-logs-tab.vue?vue&type=template&id=e2180e8e&scoped=true"
import script from "./bank-logs-tab.vue?vue&type=script&lang=js"
export * from "./bank-logs-tab.vue?vue&type=script&lang=js"
import style0 from "./bank-logs-tab.vue?vue&type=style&index=0&id=e2180e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2180e8e",
  null
  
)

export default component.exports